import React from 'react';
import { Card } from './ui/Card';
import { ScoreRing } from './ui/ScoreRing';
import { MessageCircleHeart } from 'lucide-react';
interface SentimentCardProps {
  highlighted?: boolean;
}
export function SentimentCard({
  highlighted
}: SentimentCardProps) {
  return <Card delay={0.1} className="flex flex-col h-full" highlighted={highlighted} data-id="element-324">
      <div className="flex items-center justify-between mb-6" data-id="element-325">
        <h2 className="text-2xl text-navy flex items-center gap-2" data-id="element-326">
          <MessageCircleHeart className="text-crimson" size={24} data-id="element-327" />
          Sentiment Analysis
        </h2>
        <div className="flex items-center gap-3" data-id="element-328">
          <ScoreRing score={8} size="sm" dynamicColor data-id="element-329" />
          <div className="bg-green-50 text-green-700 border border-green-200 px-3 py-1 rounded-full text-xs font-medium tracking-wide" data-id="element-330">
            POSITIVE
          </div>
        </div>
      </div>

      <div data-id="element-331">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-332">
          Score Reason
        </h3>
        <p className="text-sm text-gray-700 leading-relaxed" data-id="element-333">
          The conversation maintained a positive tone throughout, with both
          parties engaging constructively. The client expressed gratitude and
          willingness to proceed, indicating a positive sentiment.
        </p>
      </div>
    </Card>;
}